var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnectDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2394_2333",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2394_2333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 28.3333H21.6666V21.6666H28.3333V18.3333H21.6666V11.6666H18.3333V18.3333H11.6666V21.6666H18.3333V28.3333ZM19.9999 36.6666C17.6944 36.6666 15.5277 36.2291 13.4999 35.3541C11.4721 34.4791 9.70825 33.2916 8.20825 31.7916C6.70825 30.2916 5.52075 28.5278 4.64575 26.5C3.77075 24.4722 3.33325 22.3055 3.33325 20C3.33325 17.6944 3.77075 15.5278 4.64575 13.5C5.52075 11.4722 6.70825 9.70831 8.20825 8.20831C9.70825 6.70831 11.4721 5.52081 13.4999 4.64581C15.5277 3.77081 17.6944 3.33331 19.9999 3.33331C22.3055 3.33331 24.4721 3.77081 26.4999 4.64581C28.5277 5.52081 30.2916 6.70831 31.7916 8.20831C33.2916 9.70831 34.4791 11.4722 35.3541 13.5C36.2291 15.5278 36.6666 17.6944 36.6666 20C36.6666 22.3055 36.2291 24.4722 35.3541 26.5C34.4791 28.5278 33.2916 30.2916 31.7916 31.7916C30.2916 33.2916 28.5277 34.4791 26.4999 35.3541C24.4721 36.2291 22.3055 36.6666 19.9999 36.6666ZM19.9999 33.3333C23.7221 33.3333 26.8749 32.0416 29.4583 29.4583C32.0416 26.875 33.3333 23.7222 33.3333 20C33.3333 16.2778 32.0416 13.125 29.4583 10.5416C26.8749 7.95831 23.7221 6.66665 19.9999 6.66665C16.2777 6.66665 13.1249 7.95831 10.5416 10.5416C7.95825 13.125 6.66659 16.2778 6.66659 20C6.66659 23.7222 7.95825 26.875 10.5416 29.4583C13.1249 32.0416 16.2777 33.3333 19.9999 33.3333Z",
    fill: "#091C00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectDark);
export default __webpack_public_path__ + "static/media/connect-dark.d1eb5b6f9d6043e9c9f1d9bc7ef40e7a.svg";
export { ForwardRef as ReactComponent };